import Button from '@components/designSystem/Button'
import { Headline } from '@components/designSystem/Headline'
import { usePageHeader } from '@hooks/useHeader.ts'
import useTypedTranslation from '@hooks/useTypedTranslation'
import UserManagementTable from '@routes/Administration/UserManagementTable'
import { routesFactory } from '@utils/routes.ts'

function AdministrationRoute() {
  const { t } = useTypedTranslation()
  usePageHeader({ title: t('admin.title') })

  return (
    <div className="my-16">
      {/* User Management Section */}
      <div className='m-auto flex w-full max-w-6xl flex-col gap-2 px-4'>
        <div className='flex items-center gap-16'>
          <Headline title={t('admin.userManagement.title')} />
          <Button variant='link-color' href={routesFactory.root}>
            {t('admin.goBack')}
          </Button>
        </div>
        <p className='text-sm text-secondary'>
          {t('admin.userManagement.subtitle')}
        </p>
        <UserManagementTable />
      </div>
    </div>
  )
}

export default AdministrationRoute
